import { Link } from 'react-router-dom';
import { heroArticle } from '@/mocks/articles';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[500px] md:h-[620px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20beautiful%20cinematic%20scene%20of%20a%20cozy%20home%20theater%20room%20with%20warm%20golden%20ambient%20lighting%2C%20film%20posters%20on%20walls%2C%20comfortable%20seating%2C%20soft%20warm%20tones%2C%20cinematic%20atmosphere%2C%20rich%20textures%2C%20cozy%20evening%20vibe%2C%20film%20reel%20decoration%2C%20elegant%20interior&width=1600&height=800&seq=hero-bg-main&orientation=landscape"
        alt="妈妈的朋友 - 影视平台"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50" />

      <div className="relative z-10 w-full h-full flex items-center">
        <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
          <div className="max-w-2xl">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-500/90 text-background-50 text-xs font-medium mb-5 whitespace-nowrap">
              编辑精选
            </span>
            <h1 className="text-3xl md:text-5xl font-heading text-white leading-tight mb-4">
              {heroArticle.title}
            </h1>
            <p className="text-base md:text-lg text-white/80 leading-relaxed mb-6 max-w-xl">
              {heroArticle.excerpt}
            </p>
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
              <Link
                to={`/article/${heroArticle.slug}`}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                阅读全文
                <i className="ri-arrow-right-line" />
              </Link>
              <span className="text-sm text-white/60">
                {heroArticle.author} · {heroArticle.publishDate} · {heroArticle.readTime}
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}